<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.replenish.info.listByStorehouse"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无供货单记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :defaultParams="defaultParams"
      :actionWidth="250"
    >
      <template slot="row-info" slot-scope="scope">
        <warehouse-replenish-info :replenishInfo="scope.row" :showCost="true" />
      </template>
    </x-table>
  </div>
</template>

<script>
import warehouseReplenishInfo from '../../../../components/business/warehouseReplenishInfo.vue';
import replenishDetailPage from './__detail_storehouse.vue';
import replenishCreatePage from './__replenish_create.vue';
import replenishFromPage from './__replenish_form.vue';

export default {
  components: {
    warehouseReplenishInfo,
  },
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    storeGuid() {
      return this.pageQuery.storeGuid;
    },
    defaultParams() {
      return {
        optCancel: this.pageQuery.optCancel,
        optStatus: this.pageQuery.optStatus,
        demandGuid: this.pageQuery.demandGuid,
        queryValue: this.pageQuery.queryValue,
        storeGuid: this.pageQuery.storeGuid,
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
      this.$emit("call-event", "refresh")
    }
  },
  data() {
    return {
      fieldList: [
        {
          label: "记录信息",
          minWidth: '280',
          slot: "info",
        },
      ],
      actionList: [
        {
          label: '详情',
          linkType: 'primary',
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '补货单记录详情',
              refresh: this.refresh,
              component: replenishDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid
              }
            });
          },
        },
        {
          label: '编辑',
          linkType: 'primary',
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑补货单信息',
              refresh: this.refresh,
              component: replenishFromPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid
              },
            });
          },
        },
        {
          label: '复制',
          linkType: 'primary',
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '复制补货单信息',
              refresh: this.refresh,
              component: replenishCreatePage,
              params: {
                copyGuid: row.guid,
                copyStoreGuid: row.storeGuid,
                storeGuid: this.storeGuid,
              },
            });
          },
        },
        {
          label: '标记已采购',
          linkType: 'primary',
          disabled: (row) => {
            return row.optWaitPurchase != 1
          },
          click: (row, tag, refresh) => {
            this.$confirm('确认标记为已采购？', '确认', {
              type: 'info'
            }).then(() => {
              this.cancelLoading = true;
              this.requestApi('biz.warehouse.replenish.info.purchase', {
                guid: row.guid,
                storeGuid: row.storeGuid
              }, {
                showError: true
              }).then(() => {
                this.refresh();
              });
            });
          },
        },
        {
          label: '取消',
          linkType: 'danger',
          disabled: (row) => {
            return row.inboundGoodsCount > 0;
          },
          click: (row, tag, refresh) => {
            this.$confirm('确认取消补货单？', '警告', {
              type: 'error'
            }).then(() => {
              this.cancelLoading = true;
              this.requestApi('biz.warehouse.replenish.info.cancel', {
                guid: row.guid
              }, {
                showError: true
              }).then(() => {
                this.refresh();
              });
            });
          },
        },
      ],
    };
  }
};
</script>
